export default "__VITE_ASSET__TX8rpV3S__"